<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row v-if="!isAdmission">
      <v-col cols="12">
        <v-checkbox
          v-model="checkisFollowUp"
          label="Is Followup ?"
          true-value="true"
          false-value="false"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Next Followup Date & Time</span>
        <span class="error--text ml-1" v-if="isReadonly === false">*</span>
        <v-datetime-picker
          @click="modal = false"
          v-model="selectFollowUpdate"
          :minToDate="minToDate"
          :required="isReadonly === false ? 'required' : ''"
          :disabled="isDisabled"
        />
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Query Status</span>
        <span class="error--text ml-1" v-if="isReadonly === false">*</span>
        <v-autocomplete
          v-model="value.enquiryStageID"
          :required="isRequired"
          :disabled="isDisabled"
          @change="getEnquiryStages()"
          key="id"
          class="my-0 py-1"
          single-line
          placeholder="Select status"
          :items="enquiryStageData"
          :item-text="enquiryStageData ? 'name' : ''"
          item-value="id"
        >
        </v-autocomplete>
        <!-- {{ item && item.name ? item.name : '' }}-->
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Response</span>
        <span
          class="error--text ml-1"
          v-if="isReadonly === false && isRequired === true"
          >*</span
        >
        <v-autocomplete
          v-model="value.enquiryResponse"
          :required="isRequired"
          :disabled="isDisabled"
          key="id"
          class="my-0 py-1"
          single-line
          placeholder="Select response"
          :items="enquirySubRemarksData"
          :item-text="enquirySubRemarksData ? 'name' : ''"
          item-value="id"
        >
        </v-autocomplete>
        <!-- {{ item && item.name ? item.name : '' }}-->
      </v-col>
      <v-col cols="12" lg="8" sm="4">
        <span class="body-2 font-weight-medium">Remarks</span>
        <v-textarea
          rows="3"
          v-model="value.actionRemarks"
          maxlength="500"
          placeholder="Write Remarks"
          :readonly="isReadonly"
          :disabled="isDisabled"
          clearable
          clear-icon="mdi-close-circle"
          counter="500"
          single-line
          class="my-0 py-1"
        ></v-textarea>
      </v-col>
      <v-col cols="12" lg="12" sm="6" v-if="!enquiryCode">
        <span class="body-2 font-weight-medium"
          >How do you come to know about us?</span
        ><span class="error--text ml-1">*</span><br />
        <span class="body-2 small">You can select more than one option</span>

        <v-row>
          <v-col
            v-for="(item, index) in sourceStages"
            :key="index"
            cols="12"
            md="4"
            lg="2"
            sm="4"
            xs="12"
          >
            <v-checkbox
              v-model="selectedID"
              @change="updateSelectedItems(value)"
              :label="`${item.name}`"
              :value="item.id"
            ></v-checkbox>
          </v-col>
        </v-row>

        <div id="otherSourceName" v-if="otherSourceTextFlag">
          <span class="body-2 font-weight-medium"
            >Please Provide Other Source Name
            <span class="error--text">*</span></span
          >
          <v-text-field
            v-model="value.otherSourceName"
            name="otherSourceName"
            single-line
            placeholder="Please Provide Other Source Name"
            :rules="otherSourceRues"
            required
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import Utils from '@/utils'
import constants from '@/utils/constants'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'EnquiryFollowupElement',
  props: {
    enquiryCode: {
      default: '',
      type: String
    },
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    formMode: {
      default: '',
      type: String
    }
  },
  components: {
    VCardComponent
  },
  data: function () {
    return {
      selectedID: [],
      cardTitle: '',
      cardIcon: '',
      isAdmission: false,
      stages: [],
      showdata: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      minToDate: moment().format('YYYY-MM-DD'),
      followUpDateTime: null,
      sourceStages: [],
      enquiryStageData: [],
      enquirySubRemarksData: [],
      actionRemarks: '',
      enquiryResponse: '',
      isFollowup: false,
      isReadonly: false,
      isDisabled: false,
      isRequired: false,
      checkisFollowUp: false,
      selectFollowUpdate: new Date(),
      obj: {
        followUpDate: new Date(),
        followUpDateTime: null,
        queryInterestTypeID: '',
        sourceID: [],
        pointOfContact: '',
        guardianName: '',
        guardianMobile: '',
        guardianEmailID: '',
        isFollowUp: false
      },
      otherSourceTextFlag: false,
      invalidInput: false,
      otherSourceRues: [
        (v) => /^(?!\s)[a-zA-Z0-9_\s-]*$/.test(v) || 'No empty space'
      ]
    }
  },
  mounted () {},
  watch: {
    checkisFollowUp: async function (val) {
      this.value.isFollowUp = val
      await this.onFollowupChange(val)
      this.value.followUpDateTime = this.selectFollowUpdate = new Date()
    },
    selectFollowUpdate: async function (dateObj) {
      if (dateObj !== null) {
        this.value.followUpDateTime = this.value.followUpDate =
          moment(dateObj).format('YYYY-MM-DD HH:mm')
      } else {
        this.value.followUpDateTime = this.value.followUpDate = ''
      }
    }
  },
  async created () {
    this.value.isFollowUp = false
    this.isReadonly = true
    this.isRequired = false
    this.isDisabled = true
    await this.customCreate()
    await this.getEnquiryStages()
  },
  methods: {
    updateSelectedItems (value) {
      if (this.selectedID.indexOf(21) !== -1) {
        this.otherSourceTextFlag = true
      } else {
        this.otherSourceTextFlag = false
      }
      value.sourceID = this.selectedID
    },
    onFollowupChange: async function (val) {
      if (val === 'true') {
        this.isReadonly = false
        this.isRequired = true
        this.isDisabled = false
      } else {
        this.isReadonly = true
        this.isRequired = true
        this.isDisabled = true
      }
    },
    customCreate: async function () {
      if (this.stuData) {
        this.obj = {
          followUpDateTime: null,
          queryInterestTypeID: this.stuData.queryInterestTypeID,
          sourceID: this.value.sourceID,
          pointOfContact: this.stuData.pointOfContact,
          guardianName: this.stuData.guardianName,
          guardianMobile: this.stuData.guardianMobile,
          guardianEmailID: this.stuData.guardianEmailID,
          isFollowUp: false
        }
      }
      this.value.followUpDateTime = new Date()

      this.isWrite = Utils.helper.getIsWriteFun(this.$route)

      try {
        const { data: questions } = await http.get(
          `${constants.API_URL}/api/enquiry-questions`
        )
        this.stages = questions.filter((obj) => obj.type === 'INTEREST_TYPE')
        const { data: questions1 } = await http.get(
          `${constants.API_URL}/api/enquiry-questions`
        )
        this.sourceStages = questions1.filter(
          (obj) => obj.type === 'SOURCE_OF_CONTACT' && obj.isActive
        )
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
      if (this.formType !== 'admission') {
        this.cardTitle = 'Enter Followup Details'
        this.cardIcon = 'mdi-calendar-edit'
      } else {
        this.isAdmission = true
      }
    },
    viewdata () {
      this.showdata = this.value.pointOfContact === 'OTHER'
    },
    getEnquiryStages: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/enquiry-stages`
        )
        this.enquiryStageData = data.filter((obj) => obj.name !== 'Close')
        this.value.enquiryResponse = ''
        _.filter(this.enquiryStageData, (item) => {
          if (item.id === this.value.enquiryStageID) {
            this.enquirySubRemarksData = item.enquirySubRemarks
              ? item.enquirySubRemarks
              : []
          }
        })
        if (!_.isEmpty(this.enquirySubRemarksData)) {
          this.isRequired = true
        } else {
          this.isRequired = false
        }
        this.loadingComponent.close()

        return this.enquirySubRemarksData
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      }
    }
  }
}
</script>
